import { ModalDialog } from '@acceso/design-system';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { VideoPlayer } from '../Video/VideoPlayer';

type TVideoModalProps = {
  isOpen: boolean;
  url: string;
  onClose: () => void;
  title?: string;
};
export function VideoModal({ isOpen, onClose, url, title }: TVideoModalProps) {
  const { t } = useTranslation();
  return createPortal(
    <ModalDialog
      isOpen={isOpen}
      heading={title || ''}
      className="flex h-[632px]"
      actionLabel={t('Cerrar')}
      size="large"
      lineSeparator
      onClose={onClose}
      onAction={() => {}}
      linkLabel=""
    >
      <div className="flex h-full w-full">
        <VideoPlayer
          url={url}
          customControls
          controls={false}
          fullWidth
          customControlsStyles={{
            zIndex: 100,
          }}
        />
      </div>
    </ModalDialog>,
    document.body
  );
}
